import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Minus, Plus, Zap } from "lucide-react";
import { toast } from "sonner";
import { http, imgSrc, money, RARITY } from "@/lib/api";
import { useStore } from "@/context/StoreContext";

export default function ProductPage() {
  const { id } = useParams();
  const { add, currency, priceOf, setCartOpen } = useStore();
  const [p, setP] = useState(null);
  const [err, setErr] = useState(false);
  const [qty, setQty] = useState(1);

  useEffect(() => { http.get(`/products/${id}`).then((r) => setP(r.data)).catch(() => setErr(true)); }, [id]);

  if (err) return <div className="max-w-7xl mx-auto px-8 py-20 text-slate-400" data-testid="product-not-found">Produto não encontrado. <Link to="/" className="text-violet-400">Voltar</Link></div>;
  if (!p) return <div className="max-w-7xl mx-auto px-8 py-20 text-slate-500">Carregando...</div>;

  const soldOut = p.stock !== null && p.stock !== undefined && p.stock <= 0;
  const r = RARITY[p.rarity] || RARITY.comum;
  const buy = (open) => { add(p, qty); toast.success("Adicionado ao carrinho"); if (open) setCartOpen(true); };

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white" data-testid="product-back-link"><ArrowLeft className="w-4 h-4" /> Voltar à loja</Link>
      <div className="grid lg:grid-cols-2 gap-10 mt-8">
        <div className="rounded-3xl overflow-hidden border border-white/10 aspect-[4/3] rise">
          <img src={imgSrc(p.image)} alt={p.name} className="w-full h-full object-cover" />
        </div>
        <div className="rise" style={{ animationDelay: "100ms" }}>
          <span className={`text-[10px] uppercase tracking-widest font-semibold px-2 py-1 rounded border ${r.cls}`}>{r.label}</span>
          <h1 className="font-heading font-extrabold text-4xl sm:text-5xl tracking-tight mt-4" data-testid="product-detail-name">{p.name}</h1>
          <p className="font-mono text-3xl font-bold mt-6" data-testid="product-detail-price">{money(priceOf(p), currency)}</p>
          <p className="text-xs text-slate-500 mt-1 font-mono">
            {money(p.price_brl, "BRL")} via Pix · {money(p.price_eur, "EUR")} via MB Way
          </p>
          <p className="text-slate-300 mt-6 leading-relaxed whitespace-pre-line" data-testid="product-detail-description">{p.description}</p>
          <div className="flex items-center gap-2 mt-6 text-sm text-amber-300"><Zap className="w-4 h-4" /> Entrega após confirmação do pagamento</div>
          {p.stock !== null && p.stock !== undefined && <p className="text-sm text-slate-400 mt-2" data-testid="product-detail-stock">{soldOut ? "Esgotado" : `${p.stock} em estoque`}</p>}
          <div className="flex flex-wrap items-center gap-3 mt-8">
            <div className="flex items-center h-12 rounded-full bg-white/5 border border-white/10 px-2">
              <button className="w-8 h-8 grid place-items-center hover:text-white text-slate-400" onClick={() => setQty(Math.max(1, qty - 1))} data-testid="product-qty-decrease"><Minus className="w-4 h-4" /></button>
              <span className="font-mono w-8 text-center" data-testid="product-qty-value">{qty}</span>
              <button className="w-8 h-8 grid place-items-center hover:text-white text-slate-400" onClick={() => setQty(Math.min(99, qty + 1))} data-testid="product-qty-increase"><Plus className="w-4 h-4" /></button>
            </div>
            <button disabled={soldOut} onClick={() => buy(false)} data-testid="product-add-to-cart-button"
              className="h-12 px-6 rounded-full border border-white/15 hover:bg-white/10 transition-colors font-semibold disabled:opacity-30">Adicionar ao carrinho</button>
            <button disabled={soldOut} onClick={() => buy(true)} data-testid="product-buy-now-button"
              className="h-12 px-7 rounded-full bg-violet-600 hover:bg-violet-500 transition-colors font-semibold disabled:opacity-30">Comprar agora</button>
          </div>
        </div>
      </div>
    </div>
  );
}
